<app-dialog-wrapper>
  <div class="restaurant">
    <app-button
      class="restaurant__close-btn"
      [style]="ButtonStyle.Transparent"
      [size]="ButtonSize.Icon"
      (click)="dialogRef.close()"
    >
      <i class="icon-cross-circle"></i>
    </app-button>
    <div class="restaurant__content">
      <div class="restaurant__header">
        <h2 class="restaurant__header__title" [innerHTML]="restaurant.name"></h2>
        <img
          class="restaurant__header__img"
          loading="lazy"
          [src]="restaurant.main_icon"
          alt="logo"
        />
      </div>
      <div class="restaurant__info">
        <div
          class="restaurant__info__item restaurant__info__item--with-expand"
          [ngClass]="
            isRestaurantOpen() ? 'restaurant-opened' : 'restaurant-closed'
          "
        >
          <div class="restaurant__info__item__content">
            <div class="restaurant__info__item__header">
              <div class="restaurant__info__item__title">
                <i class="restaurant__info__item__icon icon-clock-outline"></i>
                @if (isRestaurantOpen()) {
                  <p>Open now</p>
                } @else if (isTodayHoliday()) {
                  <p>Closed for {{ todayHolidayReason() || 'Holiday' }}</p>
                } @else {
                  <p>Currently Closed</p>
                }
              </div>
              <app-button
                [style]="ButtonStyle.Secondary"
                [outline]="true"
                class="restaurant__info__item__action"
                (click)="toggleWorkingHoursExpanded()"
              >
                <div class="btn-content">
                  <p>See full work hours</p>
                  <i
                    class="icon-chevron-down"
                    [ngClass]="{ 'rotate-180': workingHoursExpanded() }"
                  ></i>
                </div>
              </app-button>
            </div>
            @if (workingHoursExpanded()) {
              <div class="restaurant__info__item__expand working-hours">
                @for (schedule of workingHours; track $index) {
                  <div
                    class="working-hours__item"
                    [ngClass]="{
                      'current-day': currentWeekday() === schedule.weekday
                    }"
                  >
                    <div class="working-hours__item__weekday">
                      {{ schedule.weekday }}
                    </div>
                    <div class="working-hours__item__schedule">
                      {{ schedule.start_time | uppercase }} -
                      {{ schedule.close_time | uppercase }}
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="restaurant__info__item">
          <div class="restaurant__info__item__title">
            <i class="icon-pin-outline"></i>
            <p>{{ restaurant.address }}</p>
          </div>
          <app-button
            [style]="ButtonStyle.Secondary"
            [outline]="true"
            class="restaurant__info__item__action"
            (click)="openGoogleMapsLocation(restaurant.address)"
          >
            <div class="btn-content">
              <p>View Directions</p>
              <i class="icon-arrow-top-right"></i>
            </div>
          </app-button>
        </div>
        @if (restaurant.phone) {
          <div class="restaurant__info__item">
            <div class="restaurant__info__item__title">
              <i class="icon-phone-outline"></i>
              <p>{{ restaurant.phone | phone }}</p>
            </div>
            <app-button
              (click)="initPhoneCall(restaurant.phone)"
              [style]="ButtonStyle.Secondary"
              [outline]="true"
              class="restaurant__info__item__action"
            >
              <div class="btn-content">
                <p>Give them a call</p>
                <i class="icon-arrow-top-right"></i>
              </div>
            </app-button>
          </div>
        }
        <!-- hidden for now as far as there is no website data in restaurant model -->
        <!-- <div class="restaurant__info__item">
          <div class="restaurant__info__item__title">
            <i class="icon-monitor"></i>
            <p></p>
          </div>
          <app-button
            [style]="ButtonStyle.Secondary"
            [outline]="true"
            class="restaurant__info__item__action"
          >
            <div class="btn-content">
              <p>Visit website</p>
              <i class="icon-arrow-top-right"></i>
            </div>
          </app-button>
        </div> -->
      </div>
      @if (aboutUs) {
        <div class="restaurant__description">
          <p class="restaurant__description__title">About us</p>
          <div class="restaurant__description__text">
            {{
              descriptionExpanded()
                ? aboutUs
                : (aboutUs | truncate: 180)
            }}
          </div>
          @if (aboutUs.length > 180) {
            <app-button
              class="restaurant__description__btn"
              [style]="ButtonStyle.Secondary"
              (click)="toggleDescriptionExpanded()"
            >
              <div class="btn-content">
                <p>{{ descriptionExpanded() ? 'Read Less' : 'Read More' }}</p>
                <i
                  class="icon-chevron-down"
                  [ngClass]="{ 'rotate-180': descriptionExpanded() }"
                ></i>
              </div>
            </app-button>
          }
        </div>
      }
    </div>
  </div>
</app-dialog-wrapper>
